import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const includes = ['6 tomos en PDF del Megapack Constructor Elite 360', 'Calculadora Maestra en Excel con precios 2026', 'Pack de 7 contratos blindados listos para firmar', 'Checklist profesional de 150 puntos de obra', 'Guía para negociar con casas de materiales', 'Masterclass "La Psicología del Sí"'];
export function Offer() {
  return <section id="pago" className="scroll-mt-8 bg-concrete-950 py-16 sm:py-24" data-id="element-119" data-mp="p00dnjv6xf1h">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-120" data-mp="p24ratiw5sey">
        <div className="border-2 border-safety bg-concrete-900" data-id="element-121" data-mp="13xsqu5d9lrci">
          <div className="hazard-bar h-2 w-full" aria-hidden="true" data-id="element-122" data-mp="yy7tfzdqtr1w" />
          <div className="grid gap-8 p-5 sm:gap-10 sm:p-12 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-123" data-mp="z0aqv4h86mgn">
            <div data-id="element-124" data-mp="2feakxyte3hvz">
              <h2 className="font-display text-3xl uppercase leading-none text-concrete-50 sm:text-5xl" data-id="element-125" data-mp="2ad3crync4gos">
                ¿Por qué solo <span className="text-safety" data-id="element-126" data-mp="pkqq2g8zw5cx">$25 dólares</span>?
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-concrete-200" data-id="element-127" data-mp="uj1w0fw65vpv">
                Porque sé lo que es estar en la mezcla. Quiero que este Megapack
                llegue al que tiene hambre de crecer. Por el precio de una cubeta
                de impermeabilizante, te estoy dando el mapa para que dejes de ser
                empleado y te conviertas en el dueño de la obra.
              </p>
              <ul className="mt-8 space-y-3" data-id="element-128" data-mp="bsarbrn4mtht">
                {includes.map(item => <li key={item} className="flex gap-3 text-base text-concrete-200" data-id="element-129" data-mp="funx2g1virel">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-130" data-mp="fskyv8qkhrys" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col border border-concrete-700 bg-concrete-950 p-5 sm:p-7" data-id="element-131" data-mp="3o8o4za2178l0">
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-concrete-400" data-id="element-132" data-mp="ve62icgpbtuc">
                Precio de lanzamiento
              </p>
              <p className="mt-3 flex items-end gap-3" data-id="element-133" data-mp="155agb8un58nl">
                <span className="font-display text-6xl leading-none text-safety sm:text-7xl" data-id="element-134" data-mp="154qwfmlfka6x">
                  $25
                </span>
                <span className="pb-2 font-display text-2xl uppercase text-concrete-50" data-id="element-135" data-mp="cgmosvjatn1l">
                  USD
                </span>
              </p>
              <p className="mt-2 text-base text-concrete-400" data-id="element-136" data-mp="7jct4y5bgf5b">
                Aprox. $450 MXN · Pago único, sin mensualidades
              </p>

              <CtaButton size="lg" className="mt-7 w-full text-center" data-id="element-137" data-mp="hg7nr5ygxveb">
                ¡Sí, quiero mi Megapack!
                <ArrowRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-138" data-mp="1ww6qg1pbgz76" />
              </CtaButton>

              <div className="mt-auto space-y-3 pt-7 text-sm text-concrete-400" data-id="element-139" data-mp="1svo2iiqjoda9">
                <p className="flex items-start gap-2" data-id="element-140" data-mp="20ex9k5bkvzw5">
                  <DownloadIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-141" data-mp="20d2psuc1mdtn" />
                  Descarga inmediata a tu celular o compu al terminar el pago.
                </p>
                <p className="flex items-start gap-2" data-id="element-142" data-mp="1qhrfqpbkxus8">
                  <CreditCardIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-143" data-mp="1vfatzp8a27k6" />
                  Aceptamos todas las tarjetas y pago en OXXO.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}